document.addEventListener('DOMContentLoaded', function() {
  // products/rf-mg01 以外では何もしない
  if (window.location.pathname.indexOf('products/rf-mg01') === -1) return;

  const addCartButton = document.getElementById('ProductSubmitButton-template--21006727970852__main');
  if (!addCartButton) {
    console.error('Add-to-cart button not found.');
    return;
  }

  // ───────── ラベル挿入 ─────────
  const subLabel = document.createElement('div');
  subLabel.textContent = 'もしくは';
  subLabel.style.cssText = `
    color: #4f5b62;
    text-align: center;
    margin-bottom: 4px;
  `;
  addCartButton.parentNode.insertBefore(subLabel, addCartButton);

  // ───────── 文言書き換え関数 ─────────
  function setButtonText() {
    const span = addCartButton.querySelector('span');
    if (span) {
      // すでに同じ文字なら書き換えない
      if (span.textContent !== '単品で購入') {
        span.textContent = '単品で購入';
      }
    } else {
      if (addCartButton.textContent !== '単品で購入') {
        addCartButton.textContent = '単品で購入';
      }
    }
  }

  // 初回適用
  setButtonText();

  // ───────── バリアント変更時だけ再適用 ─────────
  const productForm = addCartButton.closest('form');
  if (productForm) {
    productForm.addEventListener('change', function(e) {
      // name="options[0]" などの <select> 切り替えのみ反応
      if (/^options\[\d+\]$/.test(e.target.name)) {
        setButtonText();
      }
    });
  }

  // ───────── クリックイベント（既存ロジック） ─────────
  addCartButton.addEventListener('click', function(event) {
    event.preventDefault();
    const productForm = addCartButton.closest('form');
    if (!productForm) {
      console.error('Product form not found.');
      return;
    }
    const formData = new FormData(productForm);
    fetch(productForm.action, {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(res => res.json())
    .then(() => {
      window.location.href = 'https://roofa.jp/cart';
    })
    .catch(err => console.error('Error adding product to cart:', err));
  });
});
